<template>
  <div>
    <div class="home text-center">
      <img src="../assets/aslogo.png" width="290" alt="logo">
      <h1>AIRSUSPENSION ADMINISTRATOR</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style>
.home {
  position: fixed;
  width: 100%;
  padding: 30px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1 !important;
}
.home > img {
  margin: 30px;
  padding: 20px;
  border-radius: 30px;
  background-color: #444444;
}
.home > h1 {
  color:white;
  background-color: #444444;
  border-radius: 5px;
  padding: 9px;
}
.home-buttons {
  position: fixed;
  width: 100%;
  bottom: 10px;
}
/* big landscape tablets, laptops, and desktops */
@media (min-width:1025px) {
  .home {
    width: 50%;
  }
}
</style>
